import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const slice = document.location.host.slice(-8, -3);

if (environment.production) {
  enableProdMode();
}
if (slice === 'ost:4' || slice === 'ne.au') {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}



// WEBPACK FOOTER //
// ./src/main.ts